import { render, staticRenderFns } from "./updatetable.vue?vue&type=template&id=a2085cf6&"
import script from "./updatetable.vue?vue&type=script&lang=js&"
export * from "./updatetable.vue?vue&type=script&lang=js&"
import style0 from "./updatetable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports